[
  { "id": "AL", "label": "Alabama", "value": "Alabama" },
  { "id": "AK", "label": "Alaska", "value": "Alaska" },
  { "id": "AZ", "label": "Arizona", "value": "Arizona" },
  { "id": "AR", "label": "Arkansas", "value": "Arkansas" },
  { "id": "CA", "label": "California", "value": "California" },
  { "id": "CO", "label": "Colorado", "value": "Colorado" },
  { "id": "CT", "label": "Connecticut", "value": "Connecticut" },
  { "id": "DE", "label": "Delaware", "value": "Delaware" },
  {
    "id": "DC",
    "label": "District of Columbia",
    "value": "District of Columbia"
  },
  { "id": "FL", "label": "Florida", "value": "Florida" },
  { "id": "GA", "label": "Georgia", "value": "Georgia" },
  { "id": "HI", "label": "Hawaii", "value": "Hawaii" },
  { "id": "ID", "label": "Idaho", "value": "Idaho" },
  { "id": "IL", "label": "Illinois", "value": "Illinois" },
  { "id": "IN", "label": "Indiana", "value": "Indiana" },
  { "id": "IA", "label": "Iowa", "value": "Iowa" },
  { "id": "KS", "label": "Kansas", "value": "Kansas" },
  { "id": "KY", "label": "Kentucky", "value": "Kentucky" },
  { "id": "LA", "label": "Louisiana", "value": "Louisiana" },
  { "id": "ME", "label": "Maine", "value": "Maine" },
  { "id": "MD", "label": "Maryland", "value": "Maryland" },
  { "id": "MA", "label": "Massachusetts", "value": "Massachusetts" },
  { "id": "MI", "label": "Michigan", "value": "Michigan" },
  { "id": "MN", "label": "Minnesota", "value": "Minnesota" },
  { "id": "MS", "label": "Mississippi", "value": "Mississippi" },
  { "id": "MO", "label": "Missouri", "value": "Missouri" },
  { "id": "MT", "label": "Montana", "value": "Montana" },
  { "id": "NE", "label": "Nebraska", "value": "Nebraska" },
  { "id": "NV", "label": "Nevada", "value": "Nevada" },
  { "id": "NH", "label": "New Hampshire", "value": "New Hampshire" },
  { "id": "NJ", "label": "New Jersey", "value": "New Jersey" },
  { "id": "NM", "label": "New Mexico", "value": "New Mexico" },
  { "id": "NY", "label": "New York", "value": "New York" },
  { "id": "NC", "label": "North Carolina", "value": "North Carolina" },
  { "id": "ND", "label": "North Dakota", "value": "North Dakota" },
  { "id": "OH", "label": "Ohio", "value": "Ohio" },
  { "id": "OK", "label": "Oklahoma", "value": "Oklahoma" },
  { "id": "OR", "label": "Oregon", "value": "Oregon" },
  { "id": "PA", "label": "Pennsylvania", "value": "Pennsylvania" },
  { "id": "RI", "label": "Rhode Island", "value": "Rhode Island" },
  { "id": "SC", "label": "South Carolina", "value": "South Carolina" },
  { "id": "SD", "label": "South Dakota", "value": "South Dakota" },
  { "id": "TN", "label": "Tennessee", "value": "Tennessee" },
  { "id": "TX", "label": "Texas", "value": "Texas" },
  { "id": "UT", "label": "Utah", "value": "Utah" },
  { "id": "VT", "label": "Vermont", "value": "Vermont" },
  { "id": "VA", "label": "Virginia", "value": "Virginia" },
  { "id": "WA", "label": "Washington", "value": "Washington" },
  { "id": "WV", "label": "West Virginia", "value": "West Virginia" },
  { "id": "WI", "label": "Wisconsin", "value": "Wisconsin" },
  { "id": "WY", "label": "Wyoming", "value": "Wyoming" }
]
